import appCorporates from "../../views/appCustomers/corporates.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "corporates";
  const params = ["page", "limit", "city", "active"];

  $stateProvider.state("corporates", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appCorporates,
      },
    },
    reloadOnSearch: false,
    data: { title: "Corporates" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/corporates/corporates.urls.js